import React from 'react';

const Spinner = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '60px 0'
			}}
		>
			<div
				className="spinner-border text-info"
				role="status"
				style={{ width: '3rem', height: '3rem' }}
			>
				<span className="sr-only">Chargement...</span>
			</div>
		</div>
	);
};

export default Spinner;
